'use client';

import { Link } from '@/app_components/common/Link';
import { LogoSvg } from '@/app_components/icons/LogoSvg';
import { FortuneReleaseBadge } from '@/app_components/release-tools/FortuneReleaseBadge';
import { ContentPlacement } from '@/app_lib/types/analytics';
import { cn } from '@/app_lib/utils/utils';

export const Logo = ({ className, href = '/' }: { className?: string; href?: string }) => (
  <Link
    aria-label='Go to Fortune.com homepage'
    className='inline-flex flex-col items-start gap-1'
    data-cy={ContentPlacement.Logo}
    href={href}
  >
    <LogoSvg
      className={cn('h-6 block w-auto fill-current', className)}
      data-cy={ContentPlacement.FortuneLogo}
    />
    <FortuneReleaseBadge />
  </Link>
);
